import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
const MAX_HEIGHT = 120;
export const VideoSeekbarPreviewSpritesheet = /*#__PURE__*/ forwardRef((param)=>{
    let { aspectRatio, columns, frameCount, position, rows, src } = param;
    const scaledAspectRatio = useMemo(()=>{
        const scaledWidth = Math.round(MAX_HEIGHT * aspectRatio);
        return {
            height: MAX_HEIGHT,
            width: scaledWidth
        };
    }, [
        aspectRatio
    ]);
    const backgroundSize = useMemo(()=>{
        const scaledWidth = scaledAspectRatio.width * columns;
        const scaledHeight = scaledAspectRatio.height * rows;
        return "".concat(scaledWidth, "px ").concat(scaledHeight, "px");
    }, [
        scaledAspectRatio.height,
        scaledAspectRatio.width,
        columns,
        rows
    ]);
    const backgroundPosition = useMemo(()=>{
        const currentFrame = Math.floor(position * frameCount);
        const currentRow = Math.min(rows - 1, Math.floor(currentFrame / (frameCount / rows)));
        const isLastFrame = currentFrame === frameCount;
        const currentColumn = isLastFrame ? columns - 1 : currentFrame % columns;
        return "-".concat(currentColumn * scaledAspectRatio.width, "px -").concat(currentRow * scaledAspectRatio.height, "px");
    }, [
        scaledAspectRatio.height,
        scaledAspectRatio.width,
        columns,
        frameCount,
        position,
        rows
    ]);
    return /*#__PURE__*/ _jsx("div", {
        style: {
            backgroundImage: "url(".concat(src, ")"),
            backgroundSize,
            backgroundPosition,
            ...scaledAspectRatio
        }
    });
});
VideoSeekbarPreviewSpritesheet.displayName = "VideoSeekbarPreviewSpritesheet";
